import { render, staticRenderFns } from "./service-detail-modal.vue?vue&type=template&id=4e356ab7&scoped=true&"
import script from "./service-detail-modal.vue?vue&type=script&lang=js&"
export * from "./service-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./service-detail-modal.vue?vue&type=style&index=0&id=4e356ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e356ab7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e356ab7')) {
      api.createRecord('4e356ab7', component.options)
    } else {
      api.reload('4e356ab7', component.options)
    }
    module.hot.accept("./service-detail-modal.vue?vue&type=template&id=4e356ab7&scoped=true&", function () {
      api.rerender('4e356ab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/service-detail-modal.vue"
export default component.exports